import { render, staticRenderFns } from "./NewsEditor.vue?vue&type=template&id=a24011ca&"
import script from "./NewsEditor.vue?vue&type=script&lang=js&"
export * from "./NewsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports